import { useAppSelector } from "../../../hooks";
import { getShopState } from "../../../store";

export default function Footer() {
    const { shopInfo } = useAppSelector(getShopState)
    return (
        <div className={!!shopInfo.shop_id ?
            "bg-[#182537] text-[#747C87] py-6 px-4 text-center" :
            "bg-white text-[#747C87] py-6 px-4 text-center"
        }>
            © Salekit - Nền tảng bán hàng đa kênh hợp nhất - Website - CRM - Affiliate
        </div>
    );
}